var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EEF2F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.55,
    y: 26.9339,
    width: 20.5172,
    height: 2.55964,
    rx: 1.27982,
    transform: "rotate(-50 12.55 26.9339)",
    fill: "#808080"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9608,
    y: 11,
    width: 20.5172,
    height: 2.55964,
    rx: 1.27982,
    transform: "rotate(50 13.9608 11)",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGrey);
export default __webpack_public_path__ + "static/media/Close_Icon_Grey.8645300df28876970275544824ee76d3.svg";
export { ForwardRef as ReactComponent };